import { Record } from 'immutable';

const MergeMatchInfoRecord = Record({
  create_party: null,
  id: '0_0',
  merge_event: true,
  source: 'Manual input',
  event_match_id: null,
  matched_event_id: null,
  matched_agency_id: null,
  matched_vendor_code: null,
  edited_event_id: null,
  edited_agency_id: null,
  edited_vendor_code: null,
  action: null,
  user_id: null,
  ev_tmp_guid: null
});

export class MergeMatchInfo extends MergeMatchInfoRecord {
  create_party: string;
  id: string;
  merge_event: boolean;
  source: string;
  event_match_id: null;
  matched_event_id: null;
  matched_agency_id: string;
  matched_vendor_code: string;
  edited_event_id: null;
  edited_agency_id: string;
  edited_vendor_code: string;
  action: string;
  user_id: string;
  ev_tmp_guid: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/merge-match-info.ts